<template>
  <div>
    <!--数字框-->
    <el-input-number
      :disabled="disable"
      v-if="config.rules.textConfig.type == 'number'"
      v-model="value"
      controls-position="right"
      :placeholder="'请输入' + config.cnName"
    ></el-input-number>
    <!--文本框-->
    <el-input
      :disabled="disable"
      v-else-if="config.rules.textConfig.type == 'text'"
      clearable
      v-model="value"
      :placeholder="'请输入' + config.cnName"
    ></el-input>
    <!--多行文本-->
    <el-input
      :disabled="disable"
      v-else-if="config.rules.textConfig.type == 'textarea'"
      type="textarea"
      :autosize="{ minRows: 1, maxRows: 4 }"
      clearable
      v-model="value"
      :placeholder="'请输入' + config.cnName"
    ></el-input>
  </div>
</template>
<script>
export default {
  props: ["data", "config", "disable"],
  computed: {
    value: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
};
</script>
